import { InlineIcon } from '@iconify/react';
import { GridCellProps } from '@progress/kendo-react-grid';

import GridCellBase from 'src/components/GridCellBase';
import useRedirect from 'src/hooks/useRedirect';

const AccrualLinkCell = (props: GridCellProps) => {
  const { poId } = props.dataItem;
  const { getUrl, redirect } = useRedirect();
  return (
    <GridCellBase {...props} className="k-hierarchy-cell" disableToolTip>
      <InlineIcon
        icon="mdi:link"
        className="underline text-blue-500 cursor-pointer"
        onClick={() => redirect(getUrl('poDetails')(poId))}
        fontSize={20}
      />
    </GridCellBase>
  );
};

export default AccrualLinkCell;
